import * as React from "react";
import { FC, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import axios from "axios";
import "./Styles/Counter.css"

interface props {
  rtb: {
    CampaignID: number;
    bidID: number;
    bid_price: number;
    videourl: string;
    urlredirect: string;
  };
  ap: any;
  passPortal: any;
  DeviceID: string;
  postBalance: any;
}

export const RTBVideo: FC<props> = ({ rtb, ap, passPortal, DeviceID, postBalance }) => {
  let s;
  const [maxLength, setMaxLength] = useState(0);
  let counterLocal = null; 
  const [counter, setCounter] = useState(0);
  const [showConstrol, setShowConstrol] = useState(true);
  let interval = null;
  useEffect(() => {
    _postImpressionRTBVideo(`rtb-${rtb.bidID}`);
  }, []);

  const _postImpressionRTBVideo = async (
    mediaType: string,
    portal?: boolean
  ) => {
    try {
      const fields = {
        AccessPointID: ap.ap_mac,
        LocationID: Number(ap.ap_locationid),
        DeviceID,
        CampaignID: rtb.CampaignID,
        MediaType: mediaType,
      };
      await axios.post("/impressions", { fields });
      if (portal) {
        await postBalance(rtb, "rtbVideo");

        passPortal(ap, { CampaignID: rtb.CampaignID }, DeviceID, rtb);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const playCounter = () => {
    setShowConstrol(false);
  /*   counterLocal = maxLength;
    interval = setInterval(() => {
      counterLocal = counterLocal - 1;
      setMaxLength(counterLocal);
      if (counterLocal === 0) {
        clearInterval(interval);
        _postImpressionRTBVideo(`video-${rtb.bidID}`, true);
      }
    }, 1000); */
  }
 

  return (
    <div
      className="w-100 d-flex align-items-center flex-column"
      style={{ background: "#eee", height: "75vh", position: "relative" }}
    >
      <div className="row m-0" style={{
        display: "flex",
        position: "absolute",
        right: 0,
        top: 0,
        paddingTop: "10px"
      }}>
        <div className="col-md-3 col-sm-6">
          <div className="counter">
            <span className="counter-value">{counter}</span>
          </div>
        </div>
      </div>

     

      <div className="row m-0">
        <ReactPlayer
        width="100%"
        style={{
          objectFit: "contain",
          maxHeight: "100%",
        }}
        onEnded={() => {
           _postImpressionRTBVideo(`video-${rtb.bidID}`, true)
        }}
        onPlay={() => playCounter()}
        url={rtb.videourl.includes("storage.googleapis") ? `/google-storage/${encodeURIComponent(rtb.videourl)}` : rtb.videourl}
        //url={"https://storage.googleapis.com/sharedfi-prod.appspot.com/b50a1cd0-f4af-4645-9ad2-d7055e137ef5.mp4"}
        playing={false}
        playsinline={true}
        controls={showConstrol}
        light={true}
        onDuration={(d) => {
          setMaxLength(Math.floor(d + 0.5));
          setCounter(Math.floor(d + 0.5));
        }}
        onProgress={(e) => {
          const seconds = Math.round(e.playedSeconds);
          s = maxLength - seconds;
          setCounter(s <= 0 ? 0 : s);
        }}
      />
      </div>
      <div className="row m-0" style={{
        paddingBottom: "12px"
      }}>
          <span style={{fontSize: "1rem", color: "#b52a37", lineHeight: 4, fontWeight: 600}}>Haz Click al video para acceder a WiFi</span>
      </div>
    </div>
  );
};
